var map = {
	"./1.png": 2980,
	"./10.png": 6679,
	"./11.png": 5393,
	"./12.png": 2291,
	"./2.png": 7369,
	"./3.png": 7402,
	"./4.png": 540,
	"./5.png": 1020,
	"./6.png": 3421,
	"./7.png": 6476,
	"./8.png": 6596,
	"./9.png": 9846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1704;